
import schools from '../api/schools'

export const state = {
  schools: [],
  school_pagination_data: {},
  school: ''
}

export const getters = {
  schools: state => state.schools,
  school_pagination_data: state => state.school_pagination_data,
  school: state => state.school
}

export const mutations = {
  ADD_SCHOOL (state, data) {
    state.schools.push(data)
  },
  SET_SCHOOLS (state, data) {
    state.schools = data
  },
  SET_SCHOOL_PAGINATION (state, data) {
    state.school_pagination_data = data
  },
  SHOW_SCHOOL (state, data) {
    state.school = data
  }
}

export const actions = {
  GET_SCHOOLS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      schools.get(data).then(response => {
        commit('SET_SCHOOLS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_SCHOOL_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_SCHOOL ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      schools.create(data).then(response => {
        commit('ADD_SCHOOL', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_SCHOOL ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      schools.show(id).then(response => {
        commit('SHOW_SCHOOL', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_SCHOOL ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      schools.update(data, state.school.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_SCHOOL ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      schools.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/schools.js